import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Permission' },
    { value: 2, label: 'Option' },
  ],
});
